import { Button, styled } from "@mui/material";
import { TextInput } from "components/Input/FormControl";
import UploadImageComponent from "components/Input/UploadImageComponent";
import { StyledAvatar } from "components/Shared/Dashboard/styled";
import uploadBackgroundImg from "assets/images/uploadBackground.svg";
import Tooltip, { tooltipClasses, TooltipProps } from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { forwardRef, useImperativeHandle, useRef, useState } from "react";
import { Edit } from "@mui/icons-material";
import { appSetModal } from "store/actions/appAction";
import { useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { apiUpdateProfile } from "api/appApi";

const AvatarContainer = styled("div")(({ theme }) => ({
  width: "80px",
  height: "60px",
}));

const LightTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.common.white,
    color: "rgba(0, 0, 0, 0.87)",
    boxShadow: theme.shadows[1],
    fontSize: 11,
    textAlign: "right",
  },
}));

export const HeaderLogoPalceholder = () => {
  return (
    <AvatarContainer>
      <StyledAvatar sx={{ borderRadius: 0 }} src={uploadBackgroundImg} />
    </AvatarContainer>
  );
};

const ProfileDetails = forwardRef((props, ref) => {
  const [disable, setDisable] = useState(true);
  const dispatch = useDispatch();
  const formRef: any = useRef();
  //@ts-ignore
  const userState = useSelector((state) => state).userReducer;
  const userToken = userState?.user?.token;
  const profileInitialValues = userState?.user;
  const updateProfileSubmit = (values: any) => {
    // @ts-ignore
    dispatch(apiUpdateProfile(values, userToken, null));
  };

  useImperativeHandle(
    ref,
    () => {
      return {
        submit() {
          if (formRef.current) {
            formRef?.current?.handleSubmit();
          }
        },
      };
    },
    []
  );

  return (
    <Formik
      innerRef={formRef}
      initialValues={profileInitialValues}
      onSubmit={updateProfileSubmit}
      enableReinitialize={true}
    >
      {(formik) => (
        <div className="flex container flex-col">
          <div className="flex flex-row flex-wrap md:flex-nowrap w-full gap-4">
            <UploadImageComponent
              rounded={true}
              name="avatar"
              width={164}
              height={164}
              innerWidth={125}
              innerHeight={125}
              LogoPlaceholder={HeaderLogoPalceholder}
            />
            <div className="flex flex-col">
              <div className="flex flex-row flex-wrap md:flex-nowrap justify-between gap-4">
                <TextInput required={true} name="firstName" label="نام" />
                <TextInput required={true} name="lastName" label="نام خانوادگی" />
              </div>
              <div className="flex flex-row flex-wrap md:flex-nowrap justify-between gap-4 mt-8 ">
                <div className="flex flex-1 md:w-1/2 justify-center items-end ">
                  <TextInput
                    disabled={disable}
                    required={true}
                    name="phone"
                    label="شماره موبایل"
                    //  helperText="در صورت تغییر تلفن همراه، نیاز به تایید مجدد اطلاعات و ورود دوباره به حساب کاربری خود خواهید داشت."
                  />
                </div>
                <div className="flex flex-1 md:w-1/2 justify-center items-end ">
                  <LightTooltip title="در صورت تغییر تلفن همراه، نیاز به تایید مجدد اطلاعات و ورود دوباره به حساب کاربری خود خواهید داشت">
                    <Button onClick={() => setDisable(false)}>
                      ویرایش شماره موبایل
                      <InfoOutlinedIcon style={{ width: "12px", height: "12px", marginRight: "4px" }} />{" "}
                    </Button>
                  </LightTooltip>
                </div>
              </div>
            </div>
          </div>

          <div className="flex container flex-col w-full mt-16">
            <span className="mb-16 text-[#5B5B5C] ">امنیت حساب کاربری</span>
            <div className="flex w-full flex-row items-center">
              <div>
                <AuthIcon />
              </div>
              <div className="flex flex-col items-start flex-1 mr-6 h-full justify-around">
                <span className="text-[#424242] text-base font-IRANSansMedium font-medium ">
                  رمز عبور اصلی
                </span>
                <span className="text-dark-3 text-xs">
                  برای وارد شدن به حساب کاربری بدون نیاز به رمز یک بار مصرف
                </span>
              </div>
              <div className=" flex flex-1 justify-end">
                <button
                  onClick={() => {
                    dispatch(
                      appSetModal(
                        {
                          component: "change-password",
                          title: "تغییر رمز عبور",
                          closeButton: true,
                        },
                        true
                      )
                    );
                  }}
                  className="py-2 px-4 text-white rounded"
                >
                  <Edit />
                  <span className="mr-2">تغییر رمز عبور</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Formik>
  );
});

export default ProfileDetails;

const AuthIcon = () => (
  <svg width="68" height="68" viewBox="0 0 68 68" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="68" height="68" rx="8" fill="#D6E4FF" />
    <path
      d="M29.667 46.35h-8.212c-8.233 0-10.747-2.513-10.747-10.747v-13c0-8.233 2.514-10.746 10.747-10.746H44.27c8.233 0 10.747 2.513 10.747 10.746 0 .889-.737 1.625-1.625 1.625a1.637 1.637 0 0 1-1.625-1.625c0-6.37-1.127-7.496-7.497-7.496H21.455c-6.37 0-7.497 1.126-7.497 7.496v13c0 6.37 1.127 7.497 7.497 7.497h8.212c.888 0 1.625.737 1.625 1.625s-.737 1.625-1.625 1.625Z"
      fill="#1062D0"
    />
    <path
      d="M29.667 56.143a1.637 1.637 0 0 1-1.625-1.625v-9.815c0-.888.736-1.625 1.625-1.625.888 0 1.625.737 1.625 1.625v9.815c0 .91-.737 1.625-1.625 1.625ZM29.667 37.683H12.333a1.637 1.637 0 0 1-1.625-1.625c0-.888.737-1.625 1.625-1.625h17.334c.888 0 1.625.737 1.625 1.625 0 .889-.737 1.625-1.625 1.625Z"
      fill="#1062D0"
    />
    <path
      d="M29.667 56.143h-7.064a1.637 1.637 0 0 1-1.625-1.625c0-.888.737-1.625 1.625-1.625h7.064c.888 0 1.625.737 1.625 1.625 0 .889-.737 1.625-1.625 1.625ZM49.253 56.143h-7.691c-6.002 0-8.039-2.036-8.039-8.038V35.733c0-6.001 2.037-8.038 8.039-8.038h7.691c6.002 0 8.039 2.037 8.039 8.038v12.372c0 6.023-2.037 8.038-8.039 8.038Zm-7.691-25.198c-4.247 0-4.789.542-4.789 4.788v12.372c0 4.247.542 4.788 4.789 4.788h7.691c4.247 0 4.789-.541 4.789-4.788V35.733c0-4.246-.542-4.788-4.789-4.788h-7.691Z"
      fill="#1062D0"
    />
    <path
      d="M44.787 42.262c0-.259.104-.434.31-.528a.66.66 0 0 1 .62 0c.208.093.31.27.31.528 0 1.085-.128 2.093-.387 3.024-.258.93-.62 1.825-1.086 2.683-.123.227-.3.336-.527.326a.677.677 0 0 1-.543-.295c-.134-.197-.14-.403-.015-.62.424-.797.75-1.598.977-2.404.227-.817.341-1.722.341-2.714Zm1.8 5.816c-.104.227-.27.346-.497.356a.69.69 0 0 1-.558-.264c-.145-.175-.166-.382-.062-.62.382-.817.672-1.664.868-2.543.207-.89.31-1.804.31-2.745 0-.383-.114-.683-.341-.9-.217-.227-.517-.34-.9-.34-.382 0-.687.113-.914.34-.218.217-.326.517-.326.9 0 .92-.12 1.794-.357 2.62a10.408 10.408 0 0 1-.961 2.327c-.124.227-.3.336-.528.326a.722.722 0 0 1-.542-.31c-.135-.187-.14-.388-.016-.605.372-.672.657-1.36.853-2.063a8.21 8.21 0 0 0 .31-2.295c0-.445.109-.858.326-1.24.227-.383.532-.683.915-.9a2.385 2.385 0 0 1 1.24-.342c.445 0 .859.114 1.241.342.383.217.683.517.9.9.227.382.34.795.34 1.24a13.29 13.29 0 0 1-.34 3.008 13.04 13.04 0 0 1-.962 2.807Zm5.024-5.816c0 .258-.103.44-.31.542a.724.724 0 0 1-.62 0c-.207-.103-.31-.284-.31-.542 0-.92-.218-1.758-.652-2.513a4.698 4.698 0 0 0-1.8-1.799 4.947 4.947 0 0 0-2.511-.651c-.92 0-1.763.217-2.528.651a4.731 4.731 0 0 0-1.784 1.8 4.947 4.947 0 0 0-.651 2.512c0 .258-.104.44-.31.542a.724.724 0 0 1-.62 0c-.208-.103-.31-.284-.31-.542 0-1.117.278-2.15.837-3.102a6.1 6.1 0 0 1 2.264-2.264 6.02 6.02 0 0 1 3.102-.838c1.116 0 2.15.28 3.101.838a5.954 5.954 0 0 1 2.264 2.264 6.02 6.02 0 0 1 .838 3.102Zm-2.667 4.947c-.083.238-.238.372-.466.403a.667.667 0 0 1-.59-.201c-.164-.166-.2-.367-.108-.605.228-.672.404-1.396.528-2.171a14.05 14.05 0 0 0 .201-2.373c0-.59-.134-1.122-.403-1.598a2.69 2.69 0 0 0-1.101-1.1 3.188 3.188 0 0 0-1.598-.404c-.589 0-1.121.134-1.597.403a2.79 2.79 0 0 0-1.117 1.101 3.29 3.29 0 0 0-.387 1.598c0 .651-.078 1.287-.233 1.907a7.413 7.413 0 0 1-.605 1.69c-.113.228-.29.342-.527.342a.676.676 0 0 1-.558-.28c-.135-.185-.145-.397-.031-.635.227-.424.403-.894.527-1.411a6.886 6.886 0 0 0 .186-1.613 4.299 4.299 0 0 1 2.156-3.753 4.257 4.257 0 0 1 2.186-.59c.786 0 1.51.197 2.172.59.672.382 1.199.91 1.582 1.582.392.661.589 1.385.589 2.17 0 .859-.072 1.722-.217 2.59a12.68 12.68 0 0 1-.59 2.358Z"
      fill="#1062D0"
    />
  </svg>
);
